import { convertUtcToLocalDate } from 'library/time';

export const formatUserAvailabilityCycleItem = (item = {}) => ({
  ...item,
  start_datetime: convertUtcToLocalDate(item.start_datetime),
  end_datetime: convertUtcToLocalDate(item.end_datetime)
});

export const formatUserAvailabilityCycleList = (list = []) => list.map(item => ({
  ...item,
  availability_cycle__name: item.availability_cycle.name,
  start_datetime: convertUtcToLocalDate(item.start_datetime),
  end_datetime: convertUtcToLocalDate(item.end_datetime)
}));

export const formatAvailabilityCycleLegs = (list = []) => list.map(({ id, order, leg }) => ({
  id,
  order,
  name: leg.name,
  type: leg.type.name,
  duration: leg.duration,
  is_workable: leg.type.is_workable
}));
